import {useMemo, useState} from 'react'
import {Flex, Button, RangeCalendar} from '@binance/uikit'
import Moment from 'moment'
import {getDateRange} from 'utils/common'
import styled from 'styled-components'

const FlexWrap = styled(Flex)`
  .ant-calendar-picker-input {
    display: flex;
    justify-content: center;
    border-radius: 2px;
    align-items: center;
    height: 17px;
    width: 160px !important;
    font-size: 12px;
    line-height: 16px;
    color: #848e9c;
    background: #2a2f37;
    border: 0.5px solid #48515d;
    text-align: center;
    outline: none;

    ::placeholder {
      color: #848e9c;
    }
  }
`

export default function ToolBar ({
  i18n, activeColor = '', handleDateChange, ...rest
}) {
  const [startTime, setStartTime] = useState(0)
  const [endTime, setEndTime] = useState(0)
  const [status, setStatus] = useState(activeColor)
  return useMemo(
    () => (
      <Flex px={2} justifyContent="space-between" alignItems="center" height="32px" bg="toolbar">
        <Flex alignItems="center">
          <Button
            ml={0}
            variant="small"
            glossy={false}
            color={status === 'd' ? 'primary' : undefined}
            onClick={() => {
              setStatus('d')
              const {start, end} = getDateRange('1d')
              handleDateChange({
                ...rest,
                startTime: start,
                endTime: end
              })
            }}
          >
            {i18n.oneDay || '1 Day'}
          </Button>
          <Button
            variant="small"
            glossy={false}
            color={status === 'w' ? 'primary' : undefined}
            onClick={() => {
              setStatus('w')
              const {start, end} = getDateRange('1w')
              handleDateChange({
                ...rest,
                startTime: start,
                endTime: end
              })
            }}
          >
            {i18n.oneWeek || '1 Week'}
          </Button>
          <Button
            variant="small"
            glossy={false}
            color={status === 'm' ? 'primary' : undefined}
            onClick={() => {
              setStatus('m')
              const {start, end} = getDateRange('1m')
              handleDateChange({
                ...rest,
                startTime: start,
                endTime: end
              })
            }}
          >
            {i18n.oneMonth || '1 Month'}
          </Button>
          <Button
            variant="small"
            glossy={false}
            color={status === '3m' ? 'primary' : undefined}
            onClick={() => {
              setStatus('3m')
              const {start, end} = getDateRange('3m')
              handleDateChange({
                ...rest,
                startTime: start,
                endTime: end
              })
            }}
          >
            {i18n.threeMonth || '3 Month'}
          </Button>
        </Flex>
        <FlexWrap alignItems="center">
          <RangeCalendar
            onChange={(startDate, endDate) => {
              startDate = new Date(`${Moment(startDate).format('YYYY-MM-DD')} 00:00:00`).getTime()
              endDate = new Date(`${Moment(endDate).format('YYYY-MM-DD')} 23:59:59`).getTime()
              setStartTime(startDate)
              setEndTime(endDate)
            }}
          />
          <Button
            onClick={() => {
              setStatus('search')
              handleDateChange({
                ...rest,
                startTime,
                endTime
              })
            }}
            color={status === 'search' ? 'primary' : '#F0B90B'}
            type="primary"
            variant="small"
            glossy={false}
            style={{background: 'rgba(240, 185, 11, 0.15)', border: '0.5px solid #F0B90B'}}
          >
            {i18n.search || 'Search'}
          </Button>
        </FlexWrap>
      </Flex>
    ),
    [endTime, handleDateChange, i18n, rest, startTime, status]
  )
}
